var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.headerComponent)?_c(_vm.headerComponent,{tag:"component"}):_vm._e(),(_vm.navigationComponent)?_c(_vm.navigationComponent,{tag:"component"}):_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.footerComponent)?_c(_vm.footerComponent,{tag:"component"}):_vm._e(),_c('NoteDialog'),_c('NoteSnackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }